// Client-side validation for the OpenAI connector's project application keys (Settings →
// Integrations → OpenAI). Mirrors the backend GrcConnectorsController rules so the user sees the
// same sentence before the request is sent: trimmed, blank lines dropped, duplicates collapsed,
// a case-sensitive "sk-proj-" prefix checked before the cap, and the cap counted after
// de-duplication. The backend stays the enforcement boundary. Errors never echo a key.

export const OPENAI_PROJECT_KEY_PREFIX = "sk-proj-";
export const OPENAI_MAX_PROJECT_KEYS = 50;

export const OPENAI_PROJECT_KEY_FORMAT_ERROR =
  "Project keys must be OpenAI project application keys (sk-proj-…). An admin key cannot read the Agents API.";
export const OPENAI_PROJECT_KEY_COUNT_ERROR = "Too many project keys. Supply at most 50.";

/** One key per line, trimmed, blank lines dropped, duplicates collapsed (order kept). */
export function parseOpenAiProjectKeys(text) {
  if (typeof text !== "string") return [];
  const seen = new Set();
  for (const line of text.split(/\r?\n/)) {
    const key = line.trim();
    if (key) seen.add(key);
  }
  return [...seen];
}

/**
 * Validates the project-keys text.
 * @returns {{ ok: boolean, error: string|null, keys: string[] }} keys is empty for blank text,
 *          which callers treat as "leave the stored keys unchanged", never as a clear.
 */
export function validateOpenAiProjectKeys(text) {
  const keys = parseOpenAiProjectKeys(text);
  if (keys.some(k => !k.startsWith(OPENAI_PROJECT_KEY_PREFIX)))
    return { ok: false, error: OPENAI_PROJECT_KEY_FORMAT_ERROR, keys: [] };
  if (keys.length > OPENAI_MAX_PROJECT_KEYS)
    return { ok: false, error: OPENAI_PROJECT_KEY_COUNT_ERROR, keys: [] };
  return { ok: true, error: null, keys };
}
